import { useTranslation } from 'react-i18next';
import SpeechBubble from '../../FirstAid/components/SpeechBubble/SpeechBubble';
import mascot from '../../../assets/designSystem/icons/StaticPages/Symptoms/Adult/correct.svg';

export default function CorrectAnswer({ answer }) {
  const { t } = useTranslation();
  return (
    <div className="congrats">
      <SpeechBubble mascot={mascot} text={t('staticPages.signsAndSymptoms.adult.title2')} />
      <p style={{ textAlign: 'center' }}>{t(answer)}</p>
      <div className="congrats__footer" />
    </div>
  );
}
